import React, { Fragment, useEffect } from "react";
import { Typography, Container, Paper } from "@material-ui/core";
import NewNavbar from '../../new-components/NewNavbar'
import NewPageHeader from "../../new-components/NewPageHeader";
import NewOverrides from '../../new-components/NewOverrides'
import NewDesignSystem from '../../new-components/NewDesignSystem'
import NewFooter from '../../new-components/NewFooter'
import NewMadeWith from '../../new-components/NewMadeWith'
import NewScrollTop from '../../new-components/NewScrollTop'
import "./style.scss";

const TermsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <NewNavbar/>
      <NewOverrides/>
      <NewDesignSystem/>

      <NewPageHeader />
      <div className="terms-wrapper">
      <Container maxWidth="lg">
        <Paper className="terms-container">
          <Typography variant="h3" component="h1" className="terms-title">
            Termeni și Condiții theOilsBabe
          </Typography>

          <div className="terms-content">
            <section className="terms-section">
              <Typography variant="h5" component="h2">
                1. Acceptarea Termenilor
              </Typography>
              <Typography variant="body1" paragraph>
                Prin accesarea și utilizarea platformei theOilsBabe (denumită în continuare "Platforma"), 
                acceptați în mod expres și necondiționat să fiți legați de acești Termeni și Condiții. 
                Dacă nu sunteți de acord cu oricare dintre acești termeni, vă rugăm să încetați 
                imediat utilizarea serviciilor noastre.
              </Typography>
            </section>

            <section className="terms-section">
              <Typography variant="h5" component="h2">
                2. Despre Serviciile Noastre
              </Typography>
              <Typography variant="body1" paragraph>
                theOilsBabe este o platformă educațională digitală independentă, dedicată exclusiv 
                distribuitorilor și utilizatorilor de uleiuri esențiale doTERRA, oferind:
              </Typography>
              <ul>
                <li>Cursuri video specializate despre uleiurile esențiale doTERRA și aplicațiile acestora</li>
                <li>Materiale educaționale, eBook-uri și ghiduri practice</li>
                <li>Instrumente avansate pentru dezvoltarea și optimizarea afacerii doTERRA</li>
                <li>Acces la conținut exclusiv bazat pe rangul și statutul dvs. în hierarhia doTERRA</li>
                <li>Secțiuni interactive Q&A și sesiuni de mentorat</li>
                <li>Comunitate privată pentru schimb de experiențe și networking</li>
              </ul>
            </section>

            <section className="terms-section">
              <Typography variant="h5" component="h2">
                3. Conturile de Utilizator și Accesul la Platformă
              </Typography>
              <Typography variant="body1" paragraph>
                Pentru a accesa serviciile noastre complete, trebuie să vă creați un cont personal. 
                Prin înregistrare, vă angajați să:
              </Typography>
              <ul>
                <li>Furnizați informații corecte, complete și actualizate despre persoana dvs.</li>
                <li>Mențineți confidențialitatea și securitatea parolei și datelor de acces</li>
                <li>Notificați imediat administrația despre orice utilizare neautorizată a contului</li>
                <li>Nu partajați, nu vindați și nu transferați accesul la cont altor persoane</li>
                <li>Să nu creați conturi multiple sau false pentru a obține avantaje nemeritate</li>
                <li>Să actualizați informațiile de contact și statutul doTERRA când acestea se modifică</li>
              </ul>
            </section>

            <section className="terms-section">
              <Typography variant="h5" component="h2">
                4. Utilizarea Datelor, Integrările Platformei și Protecția Confidențialității
              </Typography>
              <Typography variant="body1" paragraph>
                Prin acceptarea acestor termeni și utilizarea platformei, consimțiți în mod expres că:
              </Typography>
              <ul>
                <li>Putem utiliza datele contului dvs. pentru integrările tehnologice ale platformei</li>
                <li>Imaginile de profil, numele și informațiile despre progresul în cursuri pot fi utilizate în cadrul platformei pentru optimizarea experienței utilizatorilor</li>
                <li>Datele despre activitatea dvs. pe platformă (progresul în cursuri, timp petrecut, preferințe) vor fi analizate pentru îmbunătățirea serviciilor</li>
                <li>NU vom partaja, vinde sau distribui NICIODATĂ datele personale sensibile (numărul de telefon, adresa de domiciliu, informații financiare)</li>
                <li>Datele dvs. vor fi stocate în sisteme securizate cu criptare avansată</li>
                <li>Puteți solicita descărcarea, modificarea sau ștergerea completă a datelor prin contactarea administrației</li>
                <li>Acceptați primirea de notificări prin email legate de cursuri, actualizări de platformă și oferte educaționale relevante</li>
              </ul>
            </section>

            <section className="terms-section">
              <Typography variant="h5" component="h2">
                5. Uleiuri Esențiale doTERRA - Disclaimer și Responsabilități
              </Typography>
              <Typography variant="body1" paragraph>
                Conținutul educațional oferit pe platforma noastră se referă exclusiv la produsele doTERRA. 
                Declarăm în mod expres că:
              </Typography>
              <ul>
                <li>Nu suntem afiliați oficial, endorsați sau certificați de doTERRA International, LLC</li>
                <li>Toate informațiile sunt destinate exclusiv educației și dezvoltării afacerii doTERRA</li>
                <li>Conținutul nu constituie sfaturi medicale, diagnostice sau terapeutice de niciun fel</li>
                <li>Nu facem afirmații despre vindecarea, tratarea sau preveniarea bolilor</li>
                <li>Utilizatorii sunt responsabili pentru propriile decizii privind utilizarea produselor</li>
                <li>Rezultatele în afaceri pot varia semnificativ de la persoană la persoană</li>
                <li>Platforma nu garantează succesul financiar în activitatea doTERRA</li>
              </ul>
            </section>

            <section className="terms-section">
              <Typography variant="h5" component="h2">
                6. Proprietatea Intelectuală și Drepturile de Autor
              </Typography>
              <Typography variant="body1" paragraph>
                Tot conținutul platformei theOilsBabe, inclusiv dar fără a se limita la:
              </Typography>
              <ul>
                <li>Cursurile video originale și materialele educaționale create de echipa noastră</li>
                <li>eBook-urile, ghidurile și documentele downloadabile</li>
                <li>Designul, interfața și funcționalitatea platformei</li>
                <li>Logo-ul, marca și identitatea vizuală theOilsBabe</li>
                <li>Sistemul de organizare și structurarea conținutului</li>
                <li>Codurile, algoritmii și tehnologia din spatele platformei</li>
              </ul>
              <Typography variant="body1" paragraph>
                Sunt protejate de drepturile de autor internaționale și nu pot fi reproduse, 
                distribuite, modificate sau utilizate în alte scopuri comerciale fără permisiunea 
                expresă și scrisă a proprietarilor.
              </Typography>
            </section>

            <section className="terms-section">
              <Typography variant="h5" component="h2">
                7. Comportamentul Utilizatorilor și Codul de Conduită
              </Typography>
              <Typography variant="body1" paragraph>
                În cadrul platformei și comunității theOilsBabe, utilizatorii se angajează să:
              </Typography>
              <ul>
                <li>Respecte ceilalți membri ai comunității, indiferent de rangul sau experiența acestora</li>
                <li>Nu partaje conținut ilegal, ofensator, discriminatoriu sau care încalcă drepturile altora</li>
                <li>Nu încerce să acceseze conținut pentru care nu au permisiuni bazate pe rangul doTERRA</li>
                <li>Nu utilizeze platforma pentru activități comerciale neautorizate sau concurențiale</li>
                <li>Nu distribute informații false despre produsele doTERRA sau despre platformă</li>
                <li>Nu facă spam, nu trimită mesaje nesolicitate altor utilizatori</li>
                <li>Raporteze imediat orice comportament neadecvat observat</li>
                <li>Respecte regulile specific ale fiecărei secțiuni a platformei</li>
              </ul>
            </section>

            <section className="terms-section">
              <Typography variant="h5" component="h2">
                8. Sisteme de Plată, Abonamente și Politica de Rambursare
              </Typography>
              <Typography variant="body1" paragraph>
                Pentru serviciile premium ale platformei:
              </Typography>
              <ul>
                <li>Plățile se procesează prin sisteme securizate și criptate</li>
                <li>Abonamentele se reînnoiesc automat, cu notificare prealabilă</li>
                <li>Politica de rambursare este de 14 zile pentru utilizatorii noi</li>
                <li>Rambursările se procesează în 5-10 zile lucrătoare</li>
                <li>Nu se acordă rambursări pentru conținutul deja accesat în întregime</li>
                <li>Suspendarea contului din motive de încălcare a termenilor anulează dreptul la rambursare</li>
              </ul>
            </section>

            <section className="terms-section">
              <Typography variant="h5" component="h2">
                9. Limitarea Răspunderii și Exonerarea de Responsabilitate
              </Typography>
              <Typography variant="body1" paragraph>
                theOilsBabe nu își asumă responsabilitatea pentru:
              </Typography>
              <ul>
                <li>Utilizarea incorectă, inadecvată sau periculoasă a informațiilor furnizate</li>
                <li>Deciziile de afaceri, investițiile sau strategiile implementate pe baza conținutului nostru</li>
                <li>Problemele tehnice temporare, întreruperile de serviciu sau pierderile de date</li>
                <li>Comportamentul altor utilizatori sau conținutul generat de aceștia</li>
                <li>Daunele directe, indirecte sau consecințiale rezultate din utilizarea platformei</li>
                <li>Nereușita în atingerea obiectivelor de afaceri sau financiare</li>
                <li>Modificările în politicile sau produsele doTERRA care afectează conținutul nostru</li>
              </ul>
            </section>

            <section className="terms-section">
              <Typography variant="h5" component="h2">
                10. Suspendarea și Închiderea Conturilor
              </Typography>
              <Typography variant="body1" paragraph>
                Ne rezervăm dreptul de a suspenda sau închide conturile pentru:
              </Typography>
              <ul>
                <li>Încălcarea repetată sau gravă a acestor termeni și condiții</li>
                <li>Activități frauduloase sau care dăunează platformei</li>
                <li>Partajarea neautorizată a conținutului cu persoane terțe</li>
                <li>Comportament abuziv către alți utilizatori sau către echipa de suport</li>
                <li>Utilizarea sistemelor automatizate pentru a accesa conținutul</li>
                <li>Neplatarea abonamentelor în termenele stabilite</li>
              </ul>
            </section>

            <section className="terms-section">
              <Typography variant="h5" component="h2">
                11. Modificarea Termenilor și Notificările
              </Typography>
              <Typography variant="body1" paragraph>
                Ne rezervăm dreptul de a modifica acești termeni oricând, cu respectarea următoarelor principii:
              </Typography>
              <ul>
                <li>Utilizatorii vor fi notificați cu minimum 30 de zile înainte de intrarea în vigoare</li>
                <li>Notificările se fac prin email și prin intermediul platformei</li>
                <li>Modificările majore vor fi evidențiate și explicate în detaliu</li>
                <li>Utilizatorii pot să își închidă contul dacă nu sunt de acord cu noile termeni</li>
                <li>Continuarea utilizării platformei după modificări constituie acceptarea noilor termeni</li>
              </ul>
            </section>

            <section className="terms-section">
              <Typography variant="h5" component="h2">
                12. Contact și Suport Tehnic
              </Typography>
              <Typography variant="body1" paragraph>
                Pentru întrebări, clarificări sau probleme tehnice legate de acești termeni 
                sau de funcționarea platformei, ne puteți contacta prin:
              </Typography>
              <ul>
                <li>Telefon: +40 743 222 996 (L-V, 09:00-18:00)</li>
                <li>WhatsApp: +40 743 222 996</li>
                <li>Telefon probleme tehnice: +40 751 313 553 (L-V, 09:00-18:00)</li>
                <li>Formularul de contact din platformă</li>
              </ul>
              <Typography variant="body1" paragraph>
                Echipa noastră de suport se angajează să răspundă în maximum 24 de ore 
                la toate solicitările legitimate.
              </Typography>
            </section>

            <section className="terms-section">
              <Typography variant="h5" component="h2">
                13. Legislația Aplicabilă și Soluționarea Litigiilor
              </Typography>
              <Typography variant="body1" paragraph>
                Acești termeni și condiții sunt guvernați exclusiv de legile României. 
                Orice litigiu decurgând din utilizarea platformei va fi soluționat prin:
              </Typography>
              <ul>
                <li>Negociere directă și medierea conflictelor</li>
                <li>Arbitrajul comercial, dacă medierea nu reușește</li>
                <li>Instanțele competente din România, ca ultimă opțiune</li>
              </ul>
            </section>

            <section className="terms-section">
              <Typography variant="h5" component="h2">
                14. Clauze Finale și Valabilitate
              </Typography>
              <Typography variant="body1" paragraph>
                Acești termeni și condiții:
              </Typography>
              <ul>
                <li>Intră în vigoare din momentul creării contului și acceptării lor</li>
                <li>Rămân valabili pe toată durata utilizării platformei</li>
                <li>Constituie acordul complet între dvs. și theOilsBabe</li>
                <li>Dacă o clauză devine inaplicabilă, restul termenilor rămân în vigoare</li>
                <li>Nu pot fi modificați decât prin acordul scris al ambelor părți</li>
              </ul>
              
              <Typography variant="body1" paragraph style={{ marginTop: '20px', fontWeight: 'bold' }}>
                Prin continuarea utilizării platformei theOilsBabe, confirmați că ați citit, 
                înțeles și acceptat în întregime acești Termeni și Condiții.
              </Typography>
            </section>
          </div>
        </Paper>
      </Container>
    </div>
      <NewFooter/>
      <NewMadeWith/>
      <NewScrollTop/>
    </Fragment>
  );
};

export default TermsPage;
